import { Flex, Tag, TagGroup, Text } from '@backstage/ui';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  RuleFragment,
  VariantFragment,
  getTypeOrNull,
} from '@spotify/confidence-graphql';

import styles from './VariantItem.module.css';

export const buildVariantUsage = (
  rules: ReadonlyArray<RuleFragment>,
): Record<string, number> => {
  const counts: Record<string, number> = {};
  rules.forEach(rule => {
    rule.assignmentSpec?.assignments?.forEach(assignment => {
      const variantName = getTypeOrNull(assignment.variant?.variant)?.name;
      if (variantName) {
        counts[variantName] = (counts[variantName] ?? 0) + 1;
      }
    });
  });
  return counts;
};

interface VariantItemProps {
  variant: VariantFragment;
  usageCount: number;
}

export const VariantItem = ({ variant, usageCount }: VariantItemProps) => {
  const inUse = usageCount > 0;
  const tagLabel = inUse ? 'In use' : 'Unused';

  return (
    <Flex align="center" gap="2">
      <Text variant="body-small">
        {extractLastNameComponent(variant.name) ?? variant.name}
      </Text>
      <TagGroup aria-label={`${variant.name} usage`}>
        <Tag
          id={variant.name}
          textValue={tagLabel}
          size="small"
          className={inUse ? styles.usageTagInUse : styles.usageTagUnused}
        >
          {tagLabel}
        </Tag>
      </TagGroup>
    </Flex>
  );
};
